module.exports = __webpack_public_path__ + "static/media/step-indicator-3.070b8443.svg";